var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useEffect, useId, useState } from 'react';
import { FAL_TIMES, FAR_TIMES } from '../../const/icons';
import i18n from '../../strings/i18n';
import { FirstNotification, NotificationContainer, RightIcon, ScreenReaderSpan } from './subcomponents';
import getLanguageFromStorage from '../../helpers/getLanguageFromStorage';
import { notificationsEllipsisInEnglish, notificationsEllipsisInSpanish } from '../../const/ellipsisNotifications';
var notificationsDataAnalytics = {
    'data-analytics': 'clicktrackingevent',
    'data-object': 'button',
    'data-reason': 'Flip card',
    'data-type': 'Expand notifications'
};
var NotificationFront = function (_a, ref) {
    var notificationList = _a.notificationList, handleOnClick = _a.handleOnClick;
    if (!notificationList.length)
        return _jsx(_Fragment, {});
    var _b = notificationList[0], name = _b.name, notificationType = _b.notificationType, notificationIcon = _b.notificationIcon, _c = _b.fontAwesomeType, fontAwesomeType = _c === void 0 ? 'far' : _c, description = _b.description, subDescription = _b.subDescription;
    var shouldStartMinimized = [
        'introRateLoanExpiredNotify',
        'introRateLoanExpiringNotify',
        'loanApprovedStillProcessingNotify',
        'waivedInterestExpiredNotify',
        'waivedInterestExpiringNotify'
    ].includes(name);
    var _d = useState(false), isEllipsis = _d[0], setIsEllipsis = _d[1];
    var _e = useState(shouldStartMinimized), isMinimized = _e[0], setIsMinimized = _e[1];
    var lang = getLanguageFromStorage();
    var handleMinimizeClick = function () {
        setIsMinimized(true);
        setTimeout(function () {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    };
    var isUrgent = ['pastDueNotify', 'attentionRequiredNotify'].includes(name);
    useEffect(function () {
        var ellipsisList = lang === 'en'
            ? notificationsEllipsisInEnglish
            : notificationsEllipsisInSpanish;
        setIsEllipsis(ellipsisList.includes(name));
    }, [lang, name]);
    var expandTextId = useId();
    if (isMinimized) {
        return (_jsxs(NotificationContainer, { children: [_jsx(FirstNotification, __assign({}, notificationsDataAnalytics, { onClickHandler: handleOnClick, type: notificationType, isTruncated: !isUrgent, notificationCount: notificationList.length, notificationCountLabel: i18n({
                        notifications: 'notifications'
                    }), icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: description, dataType: "Flip card", ref: ref, forceIsClickable: true, "aria-describedby": expandTextId })), _jsx(ScreenReaderSpan, __assign({ id: expandTextId }, { children: i18n({
                        notifications: 'expandNotification'
                    }) }))] }));
    }
    var isExpandable = (notificationList.length > 1 && !isUrgent) || isEllipsis || isMinimized;
    return (_jsxs(NotificationContainer, { children: [_jsx(FirstNotification, __assign({ onClickHandler: handleOnClick, type: notificationType, isTruncated: !isUrgent, notificationCount: isUrgent ? 0 : notificationList.length }, (isExpandable ? notificationsDataAnalytics : {}), { notificationCountLabel: i18n({
                    notifications: 'notifications'
                }), icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: _jsxs(_Fragment, { children: [description, isUrgent && (_jsx(RightIcon, { id: "minimize-notification", onClick: handleMinimizeClick, restIcon: _jsx(FontAwesomeIcon, { icon: FAL_TIMES }), activeIcon: _jsx(FontAwesomeIcon, { icon: FAR_TIMES }), type: "button", ariaLabel: i18n({ notifications: 'minimizeNotification' }) }))] }), subTitle: subDescription, dataType: "Flip card", ref: ref, "aria-describedby": isExpandable ? expandTextId : undefined })), isExpandable && (_jsx(ScreenReaderSpan, __assign({ id: expandTextId }, { children: i18n({
                    notifications: 'expandNotification'
                }) })))] }));
};
export default forwardRef(NotificationFront);
